import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import LoggedOutHeader from '../../components/header/LoggedOutHeader';
import BigLogo from '../../components/header/BigLogo';
import SetTitle from '../../components/shared/SetTitle';
import { request, handleRequestErrors } from '../../helpers/Requests'

class Logout extends Component {

  state = {
    loggedOut: false
  };

  componentDidMount() {
    request("DELETE", `/v1/a/sessions`, "")
      .then((data) => {
        localStorage.removeItem('organisation');
        localStorage.removeItem('organisationName');
        localStorage.removeItem('access_levels');
        localStorage.removeItem('license');

        this.setState({loggedOut: true})
      })
      .catch(error => handleRequestErrors(this, error))
  }

  renderResponse(state) {
    if (state.loggedOut) {
      return (
        <div>
        <p>You have been successfully logged out.</p>
        <p><Link to={'/login'}>Click here to log in again.</Link></p>
        </div>
      );
    }
    else {
      return (
        <div>
          <p>Sorry, there's been a problem.</p>
          <p>Try going back to the <Link to={'/'}>homepage</Link>.</p>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="login-page">
        <SetTitle title={"Logout"} />
        <LoggedOutHeader />

        <div className="center-container">
          <div className="login-box">
            <p className="welcome-to">Thank you for using...</p>

            <BigLogo />

            <div className="logout-message">
              {
                this.renderResponse(this.state)
              }
            </div>

          </div>
        </div>

      </div>
    );
  }
}

export default Logout;
